export const devicesHomepagePath = "/devices"
export const activateDevicePath = `${devicesHomepagePath}/activation/bulk`
export const purchasePhonesPath = `${devicesHomepagePath}/phones`
export const purchasePhonePath = `${devicesHomepagePath}/phones/order/:sku`
export const claimDevicesPath = `${devicesHomepagePath}/claim`
export const claimReportPath = `${devicesHomepagePath}/claims/:claimId`
